{
  "steps": {
    "price_list": {
      "title": "Price list",
      "subtitle": "Holds your prices"
    },
    "customer_group": {
      "title": "Customer group",
      "subtitle": "Gets the prices"
    },
    "customer": {
      "title": "Customer",
      "subtitle": "Sees the prices"
    }
  },
  "connectors": {
    "assign": "assign",
    "tag": "tag"
  }
}
